import mixpanel from 'mixpanel-browser';

import appConfig from '../config/app.config';

if (appConfig.isLiveEnvironment()) {
  mixpanel.init(appConfig.mixpanel.token);
  mixpanelDevLogger('Mixpanel Initialized');
}

function mixpanelDevLogger(message: string) {
  if (!appConfig.isProductionEnvironment() && appConfig.mixpanel.devLoggerEnabled) {
    console.log(`[Mixpanel]: ${message}`);
  }
}

export const mixpanelEventHandler = (event: string, properties?: object): void => {
  if (!appConfig.isLiveEnvironment()) {
    console.log('Mixpanel event: ', event, properties);
    return;
  }
  mixpanel.track(event, properties);
  mixpanelDevLogger(`Event Tracked - ${event}`);
};

export const mixpanelReset = () => {
  mixpanel.reset();
  mixpanelDevLogger('Reset');
};
